export const SUPPORT_EMAIL = process.env.REACT_APP_TEAM_EMAIL || 'hey@rentanythingstore.com';
